<script>
import { h, Transition } from 'vue'
import './v-accordion-styles.scss'
export default {
  props: {
    modelValue: { type: Number, required: false, default: undefined },
    areArrowsVisible: { type: Boolean, required: false, default: true },
  },
  mounted() {
    this.filterTags(this.$slots.default(), 'accordion-header', 'headers')
    this.filterTags(this.$slots.default(), 'accordion-content', 'contents')
  },
  data() {
    return {
      headers: [],
      contents: [],
    }
  },
  computed: {
    parsedSlots() {
      const headers = []
      const contents = []
      const walk = (vnodes) => {
        vnodes?.forEach(e => {
          if (e.type?.name === 'accordion-header') headers.push(e)
          if (e.type?.name === 'accordion-content') contents.push(e)
          if (Array.isArray(e.children)) walk(e.children)
        })
      }
      walk(this.$slots.default?.() ?? [])
      return { headers, contents }
    },
    vnodes() {
      const { headers, contents } = this.parsedSlots
      return headers.flatMap((header, i) => [
        h('div',
          { class: [header.props?.class, 'v-accordion__header'] },
          [
            ...this.areArrowsVisible ? [h('i', {
              class: 'material-symbols v-accordion__header-icon',
              innerHTML: i === this.modelValue ? 'expand_less' : 'expand_more'
            })] : [],
            h(header, {
              onClick: _ => this.$emit('update:modelValue', i === this.modelValue ? -1 : i),
            }),
          ]
        ),
        h(Transition,
          {
            name: 'expand',
            mode: 'out-in',
            onEnter: el => this.transitionEnter(el),
            onLeave: el => this.transitionLeave(el)
          },
          _ => {
            if (i === this.modelValue) return h('div', {}, contents[i])
          }
        )
      ])
    }
  },
  render() {
    return h('div', {}, { default: _ => this.vnodes })
  },
  methods: {
    filterTags(vnodesList, tag, propName) {
      vnodesList.forEach(e => {
        if (e.type.name == tag) this[propName].push(e)
        if (e.children?.length) {
          this.filterTags(e.children, tag, propName)
        }
      })
    },
    transitionEnter(el) {
      el.style.visibility = 'hidden'
      el.style.height = 'auto'
      this.$nextTick(_ => {
        const height = el.scrollHeight + 'px'
        el.style.visibility = 'visible'
        el.style.height = 0
        requestAnimationFrame(_ => {
          el.style.height = height
        })
      })
    },
    transitionLeave(el) {
      const height = getComputedStyle(el).height
      el.style.height = height
      requestAnimationFrame(_ => {
        el.style.height = 0
      })
    }
  },
  watch: {
    '$slots.default': {
      deep: true,
      handler() {
        this.headers = []
        this.contents = []
        this.filterTags(this.$slots.default(), 'accordion-header', 'headers')
        this.filterTags(this.$slots.default(), 'accordion-content', 'contents')
      }
    },
  },
}
</script>